import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { TypographyProps } from '@mui/material';
import { mq } from 'src/themes';
import { Typography } from 'src/components/atoms';

interface Props extends TypographyProps {
  children: ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4';
}

const StyledPageHeader = styled(Typography)`
  ${mq.md} {
    font-size: 24px;
  }

  ${mq.sm} {
    font-size: 20px;
  }
`;

export const PageHeader = ({ children, variant = 'h2', ...props }: Props) => {
  return (
    <StyledPageHeader variant={variant} {...props}>
      {children}
    </StyledPageHeader>
  );
};
